<div
  [stickyPopover]="contentTemplate"
  [popoverTitle]="titleTemplate"
  [autoClose]="false"
  [animation]="false"
  [openDelay]="300"
  popoverClass="header-filter-info-popover"
  placement="end-top"
  triggers="manual"
>
    <div class="form-check form-switch" style="height: 2rem !important;" [ngClass]="{'pt-3': searchInput.label !== 'Calibration observations'}">
      <input id="{{'header-filter-' + searchInput.id}}"
             class="form-check-input"
             type="checkbox"
             [checked]="this.searchInput.value === 'true'"
             (change)="toggleValue($event?.target?.checked?.toString())">
      <label class="form-check-label text-nowrap"
             id="{{'header-filter-label-' + searchInput.id}}"
             for="{{'header-filter-' + searchInput.id}}">
        {{searchInput.label}}
      </label>
    </div>
</div>

<ng-template #titleTemplate>
  {{ tooltipTitle }}
</ng-template>

<ng-template #contentTemplate>
  <ul class="list list-unstyled mb-0 d-flex flex-column gap-2" style="max-width: 20rem">
    <li>
      <strong>Info</strong>: <span [innerHtml]="tooltipTextInfo"></span>
    </li>
    <li>
      <strong>Description</strong>: <span [innerHtml]="tooltipTextDescription"></span>
    </li>
  </ul>
</ng-template>